import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { NavBar } from "../components/NavBar";

export const LegalLayout = ({ title, updated, children, testid, eyebrow = "Legal" }) => {
  const navigate = useNavigate();
  return (
    <>
      <NavBar />
      <main className="container-nc" style={{ paddingTop: 30, paddingBottom: 90, maxWidth: 760 }} data-testid={testid}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
          <button className="btn btn-ghost" onClick={() => navigate(-1)} data-testid="legal-back-btn">
            <ChevronLeft size={16} /> Back
          </button>
          <span className="eyebrow">{eyebrow}</span>
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: 600, letterSpacing: "-0.03em", margin: "0 0 6px" }}>
          {title}
        </h1>
        <p className="mono" style={{ color: "var(--muted)", fontSize: 12, marginBottom: 28 }}>
          Last updated {updated}
        </p>
        <div className="legal-body">{children}</div>
      </main>
    </>
  );
};

export const Section = ({ heading, children }) => (
  <section style={{ marginBottom: 26 }}>
    <h2 style={{ fontSize: 18, fontWeight: 600, margin: "0 0 10px" }}>{heading}</h2>
    <div style={{ color: "var(--on-surface-2)", fontSize: 15, lineHeight: 1.72 }}>{children}</div>
  </section>
);
